import { PlaceholderPosition } from '@/types/quote';
import { getPlaceholderCategories } from './quotePlaceholders';

export const getSampleData = (key: string): string => {
  const sampleMap: Record<string, string> = {
    // Own company
    '{{company_logo}}': '[LOGO]',
    '{{company_name}}': 'GreenVision B.V.',
    '{{company_street}}': 'Industrieweg 10',
    '{{company_postal_code}}': '1234 AB',
    '{{company_city}}': 'Amsterdam',
    '{{company_country}}': 'Nederland',
    '{{company_full_address}}': 'Industrieweg 10, 1234 AB Amsterdam',
    '{{company_kvk}}': 'KvK 12345678',
    '{{company_btw}}': 'NL123456789B01',
    '{{company_iban}}': 'NL00 BANK 1234 5678 90',
    '{{company_bic}}': 'ABNANL2A',
    '{{company_phone}}': '+31 20 123 4567',
    '{{company_email}}': 'info@greenvision.nl',
    '{{company_website}}': 'www.greenvision.nl',
    
    // Client organization
    '{{organization_name}}': 'GreenTech Solutions B.V.',
    '{{organization_kvk}}': '12345678',
    '{{organization_btw}}': 'NL123456789B01',
    '{{organization_street}}': 'Keizersgracht 100',
    '{{organization_postal_code}}': '1015 CW',
    '{{organization_city}}': 'Amsterdam',
    '{{organization_country}}': 'Nederland',
    '{{organization_full_address}}': 'Keizersgracht 100, 1015 CW Amsterdam',
    
    // Contact
    '{{contact_name}}': 'Dhr. J. van der Berg',
    '{{contact_first_name}}': 'Jan',
    '{{contact_last_name}}': 'van der Berg',
    '{{contact_email}}': 'j.vandeberg@greentech.nl',
    '{{contact_phone}}': '+31 20 987 6543',
    '{{contact_mobile}}': '+31 6 12345678',
    '{{contact_function}}': 'Inkoop Manager',
    
    // Quote
    '{{quote_number}}': 'OFF-2025-001',
    '{{quote_title}}': 'Offerte Batterijsysteem',
    '{{quote_date}}': new Date().toLocaleDateString('nl-NL'),
    '{{valid_until}}': new Date(Date.now() + 30 * 24 * 60 * 60 * 1000).toLocaleDateString('nl-NL'),
    '{{reference}}': 'REF-2025-001',
    '{{version_number}}': '1',
    
    // Financial
    '{{subtotal}}': '€ 45.750,00',
    '{{vat_amount}}': '€ 9.607,50',
    '{{vat_rate}}': '21%',
    '{{total}}': '€ 55.357,50',
    '{{discount_amount}}': '€ 0,00',
    '{{discount_percentage}}': '0%',
    '{{payment_term}}': '14',
    '{{payment_due_date}}': new Date(Date.now() + 14 * 24 * 60 * 60 * 1000).toLocaleDateString('nl-NL'),
    
    // Project
    '{{project_name}}': 'Project Amsterdam Noord',
    '{{project_number}}': 'PRJ-2025-001',
    
    // Misc
    '{{current_date}}': new Date().toLocaleDateString('nl-NL'),
    '{{owner_name}}': 'Medewerker Naam',
    
    // Additional conditions
    '{{additional_conditions}}': '[VOORWAARDEN]',
    
    // Line items table
    '{{line_items_table}}': '[REGELITEMS TABEL]',
  };
  return sampleMap[key] || key;
};

// Get default placeholder size based on type
export const getDefaultPlaceholderSize = (key: string): { width: number; height: number } => {
  if (key === '{{company_logo}}') {
    return { width: 150, height: 60 };
  }
  if (key === '{{additional_conditions}}') {
    return { width: 515, height: 80 };
  }
  if (key === '{{line_items_table}}') {
    return { width: 515, height: 200 };
  }
  return { width: 200, height: 30 };
};

export const getAllPlaceholderKeys = (): Array<{ key: string; description: string; category: string }> => {
  const categories = getPlaceholderCategories();
  const result: Array<{ key: string; description: string; category: string }> = [];
  
  categories.forEach(category => {
    category.placeholders.forEach(p => {
      result.push({
        key: p.placeholder,
        description: p.description,
        category: category.label
      });
    });
  });
  
  return result;
};

export const createDefaultPlaceholder = (key: string, x: number, y: number): PlaceholderPosition => {
  const size = getDefaultPlaceholderSize(key);
  return {
    key,
    page: 1,
    x,
    y,
    width: size.width,
    height: size.height,
    fontSize: key === '{{line_items_table}}' ? 9 : 12,
    fontWeight: 'normal',
    color: '#000000',
    align: 'left'
  };
};
